import SafetyAnchorPointListListResultModelBase from '../_generated/modelBases/safety-anchor-point-list-list-result-model-base';

export default class SafetyAnchorPointListListResultModel extends SafetyAnchorPointListListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
